import React from 'react'
import {
  Tag,
  TagLabel,
  TagLeftIcon,
  TagRightIcon,
  TagCloseButton,
} from '@chakra-ui/react'

export default function TagCustom({ size, colorScheme, price }) {
  return (
    <div>
      <Tag
        size={size}
        key={size}
        variant="subtle"
        className="mx-1"
        colorScheme={colorScheme}
      >
        <TagLabel>{price}</TagLabel>
      </Tag>
    </div>
  )
}
